export default __webpack_public_path__ + "static/media/shadow-footer-contracts.ee7e373f.svg";